/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-01-23 11:36:18                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-01-23 13:43:54                               *
 *****************************************************************************/

/* SUMMARY
  * quotationExportDescriptor: mapping descriptor data/csv
*/

import { formatLocalDate } from "../timezoneUtils";

/**
* quotationExportDescriptor: mapping descriptor data/csv
*/
export const quotationExportDescriptor: EasyTech.ExportDescriptor[] = [{
  column: "ref",
  getter: (e: EasyTech.Quotation) => e.ref
}, {
  column: "date",
  getter: (e: EasyTech.Quotation) => {
    const realm = localStorage.getItem("realm") || "default";
    return e.date ? formatLocalDate(e.date, realm) : "";
  }
}, {
  column: "technician",
  getter: (e: EasyTech.Quotation) => `${e.technician.firstName} ${e.technician.lastName}`
}, {
  column: "customer",
  getter: (e: EasyTech.Quotation) => e.customer.name
}, {
  column: "contact",
  getter: (e: EasyTech.Quotation) => `${e.contact.firstName} ${e.contact.lastName}`
}, {
  column: "duration",
  getter: (e: EasyTech.Quotation) => String(e.duration)
}, {
  column: "parts cost",
  getter: (e: EasyTech.Quotation) => String(e.pricing.partsCost)
}, {
  column: "services cost",
  getter: (e: EasyTech.Quotation) => String(e.pricing.servicesCost)
}, {
  column: "technician fees",
  getter: (e: EasyTech.Quotation) => String(e.pricing.techFees)
}, {
  column: "estimated cost",
  getter: (e: EasyTech.Quotation) => String(e.pricing.estimatedCost)
}, {
  column: "technician base price",
  getter: (e: EasyTech.Quotation) => String(e.pricing.techBasePrice)
}];
/***/
